import {Icon} from 'src/common/Icon'
import type {FormData} from '../constants'
import {GUIDELINES_OPTIONS, RISK_OPTIONS, btn, btnGhost} from '../constants'

export function StepTone({
  data,
  onGenerate,
  onBack,
  onChange,
}: {
  data: FormData
  onGenerate: () => void
  onBack: () => void
  onChange: (fields: Partial<FormData>) => void
}) {
  const tone = data.guidelinesStyle || 'empowering'
  const risk = data.riskTolerance || 'balanced'

  const sectionLabel = 'text-[11px] text-black/55 uppercase tracking-[0.06em] font-semibold mb-[10px]'
  const divider = 'h-px bg-black/[0.06] my-[18px]'

  const optionBtn = (active: boolean) =>
    `text-left px-3 py-[10px] rounded-lg cursor-pointer border font-[inherit] transition-all duration-150 w-full ${
      active ? 'bg-green-neon/[0.18] border-green-neon/50' : 'bg-moss-white border-black/[0.08]'
    }`

  return (
    <div className="flex min-h-0 flex-1 animate-epg-reveal-up flex-col">
      <div className="shrink-0">
        <h2 className="m-0 mb-1 text-[28px] font-normal tracking-[-0.015em]">Policy style</h2>
        <p className="mb-4 mt-0 text-[14px] text-black/55">Choose the tone and risk level for your expense policies.</p>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto">
        <div className={sectionLabel}>Risk tolerance</div>
        <div className="flex flex-col gap-[6px]">
          {RISK_OPTIONS.map((r) => (
            <button
              key={r.value}
              onClick={() => onChange({riskTolerance: r.value})}
              className={optionBtn(risk === r.value)}
            >
              <div className="text-[13px] font-semibold">{r.label}</div>
              <div className="mt-0.5 text-[11px] text-black/55">{r.desc}</div>
            </button>
          ))}
        </div>

        <div className={divider} />

        <div className={sectionLabel}>Guidelines tone</div>
        <div className="flex flex-col gap-[6px]">
          {GUIDELINES_OPTIONS.map((g) => (
            <button
              key={g.value}
              onClick={() => onChange({guidelinesStyle: g.value})}
              className={optionBtn(tone === g.value)}
            >
              <div className="text-[13px] font-semibold">{g.label}</div>
              <div className="mt-0.5 text-[11px] text-black/55">{g.desc}</div>
            </button>
          ))}
        </div>
      </div>
      <div className="shrink-0">
        <div className="flex gap-2 pb-1 pt-3">
          <button className={`${btnGhost} flex-1 justify-center`} onClick={onBack}>
            <Icon name="right-arrow" className="size-4 rotate-180" /> Back
          </button>
          <button className={`${btn} flex-[2] justify-center !px-7`} onClick={onGenerate}>
            Choose categories →
          </button>
        </div>
      </div>
    </div>
  )
}
